import { Plus } from '@medusajs/icons';
import { toast, useToggleState } from '@medusajs/ui';
import {
  type CreateAddressInput,
  type UpdateAddressInput,
  useCreateAddress,
} from '@lib/query/mutations/customer';

import { EditAddressModal } from './edit-address-modal';

const AddAddress = () => {
  const { state, open, close: closeModal } = useToggleState(false);

  // Design Decision: Generic error messages without error logging are sufficient.
  // Users see a clear error message; detailed error tracking is handled by
  // backend monitoring and Sentry. Frontend logging is not essential here.
  // @see PR #63 review comment
  const createAddress = useCreateAddress({
    onSuccess: () => {
      toast.success('收件地址已新增', { duration: 4000 });
      closeModal();
    },
    onError: () => {
      toast.error('新增地址失敗，請稍後再試', { duration: 4000 });
    },
  });

  const handleSubmit = (data: CreateAddressInput | UpdateAddressInput) => {
    // When address={null}, EditAddressModal always submits CreateAddressInput
    createAddress.mutate(data as CreateAddressInput);
  };

  return (
    <>
      <button
        className="rounded-rounded border-ui-border-base flex flex-col justify-between border p-6"
        onClick={open}
        data-testid="add-address-button"
      >
        <span className="text-black-40 text-base">新增收件地址</span>
        <Plus />
      </button>

      <EditAddressModal
        address={null}
        modalState={state}
        closeModal={closeModal}
        onSubmit={handleSubmit}
        isPending={createAddress.isPending}
        error={createAddress.isError ? '新增地址失敗' : null}
        dataTestId="add-address-modal"
        title="新增收件地址"
        confirmText="確認新增"
      />
    </>
  );
};

export default AddAddress;
